import { render, staticRenderFns } from "./AboutInternational.vue?vue&type=template&id=7af40abb&scoped=true&"
import script from "./AboutInternational.vue?vue&type=script&lang=js&"
export * from "./AboutInternational.vue?vue&type=script&lang=js&"
import style0 from "./AboutInternational.vue?vue&type=style&index=0&id=7af40abb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af40abb",
  null
  
)

export default component.exports